export default function isMacDesktop(userAgent) {
  if (!userAgent) return false;

  const isMac = /Macintosh|Mac OS X/i.test(userAgent);
  const isPhone = /iPhone|iPad|iPod/i.test(userAgent);

  return isMac && !isPhone; // has to have Mac identifier but exclude Apple mobile
}
